import { Component } from '@angular/core';

@Component({
  selector: 'app-images-strip',
  standalone: true,
  templateUrl: './images-strip.html',
  styleUrl: './images-strip.scss',
})
export class ImagesStripComponent {}
